import React, { Component } from "react";
import Loader from '../../container/Loader';
import Home from '../../container/Home';

import api from "../../services/api";
import { ID_CLIENT, NAME_CLIENT, getToken, getAccessUser } from "../../services/auth";

import Logo from "../../assets/logo_icon.png";
import "../../styles/modulos.css";

export default class Client extends Component {

    constructor() {
        super();
        this.state = {
            clients: [],
            url: '/clientes',
        }
    }

    getClients(token, ) {
        
        api.get(this.state.url, { headers: { token } })
            .then(response => {
                this.setState({
                    clients: this.state.clients.length > 0 ?
                        this.state.clients.concat(response.data) : response.data,
                    loading: false
                })
                if (!JSON.parse(getAccessUser())) {
                    if (this.state.clients.length === 1) {
                        this.handleClick(this.state.clients[0].id, this.state.clients[0].nome)
                    }    
                }
                
            }).catch(err => console.log(err));
    }

    componentDidMount() {
        this.getClients(getToken())
    }

    handleClick(id_client, name) {
        localStorage.setItem(ID_CLIENT, id_client);
        localStorage.setItem(NAME_CLIENT, name);
        this.props.history.push("/menu");
    }


    render() {
        if (this.state.loading) return <Loader />;
        const clients = this.state.clients.map(client => {
            return (
                <div className="col" key={client.id}>
                    <div className="card">
                        <div className="modulo-item">
                            <img style={{ width: client.logo ? '50%' : '14.5%', display: 'block', marginLeft: 'auto', marginRight: 'auto' }} src={client.logo ? client.logo : Logo} alt="" />
                            <hr />
                            <header style={{ textAlign: 'center' }}>{client.nome}</header>
                            <button onClick={this.handleClick.bind(this, client.id, client.nome)} className="btn btn-primary btn-acessar" name="button" style={{ display: 'block' }}>Acessar</button>
                        </div>
                    </div>
                </div>
            )
        })
        const count = clients.length
        const isLoggedIn = this.state.clients.length;
        return (
            
            <Home menu={false} client={false} html={
                <>
                { isLoggedIn === 2 ?
                    <div className="modulos-wrapper">
                        <div className="modulos-title-wrapper">
                            <h4>Selecione o Cliente</h4>
                        </div>
                        <div className="modulos-holder ">
                            <div className={`row row-cols-md-${count === 1 ? 1 : 3}`}>
                                {clients}
                            </div>
                        </div>
                    </div>
                    : ''
                }
                </>
                }
            />
        )
    }
}
